import { ReactElement } from "react"
import DefaultAvtar from './../../image/ic_avatar_default.svg'
import { Flex } from "antd"
import { CSSProperties } from "@mui/material"
export const AvatarView = ({colors=["#739E72","#1C6A93","#F65B3E"], children=null}:
                               {colors?:string[],text?:string,children?:ReactElement|null}) =>{
    const defaultProps:CSSProperties={
            borderRadius:"150px",
            width:"150px", 
            height:"150px",
            overflow:"hidden",
            display:"flex",
            margin:"0px",
            padding:"0px"
        }
    
    
                                return (
        <div style={{...defaultProps,background:"linear-gradient(white 0 0) padding-box, linear-gradient(to right, "+colors.join(",")+") border-box",
                border: "2px solid transparent"}}>
                {children!=null?children:<img src={DefaultAvtar}/>}
        </div>
    )
}